import { useEffect, useState } from 'react';
import { resolveApiUrl } from '../lib/api-url';

const PRODUCTION_API = 'https://api.vortexnav.com';

type HealthStatus = 'loading' | 'ok' | 'warn' | 'degraded' | 'error';

const STATUS_DOT: Record<HealthStatus, string> = {
  loading: 'bg-amber-300 animate-pulse',
  ok: 'bg-green-400',
  warn: 'bg-yellow-300',
  degraded: 'bg-red-400',
  error: 'bg-red-400',
};

export function EnvironmentBanner() {
  const apiUrl = resolveApiUrl();
  if (apiUrl === PRODUCTION_API) return null;

  const label =
    apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')
      ? 'Local dev'
      : apiUrl.includes('staging')
        ? 'Staging'
        : 'Non-production';

  const healthUrl = `${apiUrl}/api/health`;
  const [status, setStatus] = useState<HealthStatus>('loading');

  useEffect(() => {
    let cancelled = false;
    fetch(healthUrl)
      .then((r) => r.json())
      .then((data: any) => {
        if (!cancelled) setStatus(data.status ?? 'error');
      })
      .catch(() => {
        if (!cancelled) setStatus('error');
      });
    return () => { cancelled = true; };
  }, [healthUrl]);

  return (
    <div className="bg-amber-500 text-amber-950 text-center text-xs font-medium py-1 px-2 select-none flex items-center justify-center gap-2">
      <span className={`inline-block w-2 h-2 rounded-full ${STATUS_DOT[status]}`} />
      <span>
        {label} API &mdash;{' '}
        <a
          href={healthUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-amber-800"
        >
          {apiUrl}
        </a>
      </span>
    </div>
  );
}
